"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestOnboardingState = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
/**
 * Everything the onboarding checklist needs to decide which steps are already done, in one
 * round trip. Deliberately narrow: only ids, so a workspace with many members stays cheap.
 *
 * `shifts(uncommitted: true)` is the MANAGER/working view — it contains drafts as well as
 * published shifts, so it answers "does any shift exist at all". The unaliased `shifts` is
 * the default PUBLISHED view — what employees see — so it answers "has anything been
 * published".
 *
 * `limit: 1` on the draft view only, even though both are existence checks: on the PUBLISHED
 * view any `limit` comes back empty. Verified against dev with one published shift —
 * `shifts { id }` returns it, `shifts(limit: 1)` and `shifts(limit: 5)` return `[]`, while
 * `shifts(uncommitted: true, limit: 1)` returns it. So the argument is dropped there; a
 * workspace still on the checklist has a handful of published shifts at most, and this asks
 * for nothing but their ids. Put it back once the backend paginates that view correctly —
 * until then it silently made the „published" step impossible to finish.
 */
const ONBOARDING_STATE_QUERY = (0, graphql_tag_1.default) `
  query OnboardingStateQuery($id: ID!) {
    workspace(id: $id) {
      id
      positions {
        id
        archived
      }
      terminals {
        id
      }
      members {
        userId
        roles {
          contracts {
            id
          }
        }
      }
      draftShifts: shifts(uncommitted: true, limit: 1) {
        id
      }
      publishedShifts: shifts {
        id
      }
    }
  }
`;
const requestOnboardingState = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(ONBOARDING_STATE_QUERY, { variables });
    (0, error_handler_1.processErrors)(errors);
    return data?.workspace;
};
exports.requestOnboardingState = requestOnboardingState;
exports.default = exports.requestOnboardingState;
